import type { FetchScheme } from '../node/store';

export default {
	// Группировка схем по order
	groupSchemesByOrder(schemes: FetchScheme[]): FetchScheme[][] {
		const grouped: Record<number, FetchScheme[]> = {};

		// Группируем схемы по order
		for (const scheme of schemes) {
			const order = scheme.order || 0;
			if (!grouped[order]) grouped[order] = [];
			grouped[order].push(scheme);
		}

		// Возвращаем отсортированные группы
		return Object.keys(grouped)
			.sort((a, b) => Number(a) - Number(b))
			.map((order) => grouped[Number(order)]);
	},
};
